import { ISegmentSection } from '../interfaces';
import { trackSubmit } from './section-handler';

export function userEventHandler(segment_data: ISegmentSection | null) {
  if (segment_data !== null) trackSubmit(segment_data);
}
